import { AlertTriangle } from "lucide-react";
import React from "react";

import { authModeLabel } from "@/auth/sso-messages";
import { ssoOneCProblem, useOneCBases } from "@/lib/use-onec-bases";

/** Режим входа текущей сессии — плашкой рядом с логином в шапке. Видно всегда:
 *  от режима зависит, как портал ходит в 1С (пароль подключения или JWT SSO).
 *  В SSO — ещё значок, если в учётке SSO не задан пользователь 1С. */
export function AuthModeBadge({ mode }: { mode: string | undefined }): React.ReactElement {
  return (
    <span
      data-testid="auth-mode"
      className="flex shrink-0 items-center gap-0.5 rounded bg-muted px-1 text-[10px] font-semibold uppercase tracking-wide text-muted-foreground"
    >
      {authModeLabel(mode)}
      {mode === "sso" && <SsoProblemMark />}
    </span>
  );
}

function SsoProblemMark(): React.ReactElement | null {
  const { data, error } = useOneCBases();
  const problem = error
    ? "Справочник баз 1С не загрузился"
    : data
      ? ssoOneCProblem(data.has_onec_unf)
      : null;
  if (problem === null) return null;
  return (
    <span title={problem} className="inline-flex">
      <AlertTriangle className="size-3 text-amber-600 dark:text-amber-400" aria-label={problem} />
    </span>
  );
}
